export default {
    CLASSES: {
        CMS_GALLERY: "cms-gallery",
        HIDDEN_ITEM: "hidden",
        FULLSCREEN: "fullscreen"
    },
    EVENTS: {
        THUMB_START: "thumb-start",
        THUMB_BEFORE: "thumb-before",
        NAV_BEFORE: "nav-before",
        NAV_BEFORE_RESULT: "nav-before-result",
        NAV_START: "nav-start",
        SCROLL_START: "scroll-start",
        SCROLL_END: "scroll-end",
        SCROLL_NAV_READY: "scroll-nav-ready",
        TILES_LOADED: "scroller-tiles-loaded",
        SCROLLER_GOTO: "scroller-goto",
        SCROLLER_NAV_UPDATE: "scroller-nav-update"
    },
    SELECTORS: {
        SCROLLER: ".scroller",
        NAV: ":scope > .scroller-nav",
        PREV: ':scope > .scroller-nav[data-dir="prev"]',
        NEXT: ':scope > .scroller-nav[data-dir="next"]',
        TILES: ":scope > *:not(.hidden)",
        TRACK: ":scope > .track",
        THUMBS: ":scope > .scroller > *:not(.hidden)",
        THUMBS_WITH_HIDDEN: ":scope > .scroller > *",
        BTN_CLOSE: ":scope > .icon.close",
        GALLERY: ".gallery, .gallery-single"
    },
    FULLSCREEN_URL_HASH: "#fullscreen-gallery"
};
